import { useMutation } from "@tanstack/react-query";
import { services } from "@/services/registry";
export const useMarketplaceRedirect = ()=>{
    return useMutation({
        mutationFn: (params)=>services.marketplaceService.redirect(params),
        onError: ()=>{
        // Marketplace redirect error occurred
        }
    });
};
